import { ActionType, ProTable } from "@ant-design/pro-components";
import { Button, Select, message } from "antd";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef } from "react";
import UUIDComponent from "../../components/UUIDComponent";
import { popupCategory } from "../const";

export default function HealthFeedback() {
    const { jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();

    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const columns: any[] = [
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "用户id",
            dataIndex: "userId",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "所属类别",
            dataIndex: "category",
            align: "center",
            search: false,
            valueEnum: popupCategory,
        },
        {
            title: "反馈内容",
            dataIndex: "answers",
            align: "center",
            search: false,
            render: (value: any) => {
                // 检查是否为数组
                if (!Array.isArray(value) || value.length === 0) return value || '-';
                return (
                    <div style={{ textAlign: 'left' }}>
                        {value?.map((item, index) => {
                            return (
                                <div key={index} style={{ marginBottom: '8px' }}>
                                    <div>问题：{item.question || '无问题'}</div>
                                    <div>回答：{item.answer || '无回答'}</div>
                                </div>
                            );
                        })}
                    </div>
                );
            }
        },
        {
            title: "反馈状态",
            dataIndex: "status",
            align: "center",
            search: true,
            renderFormItem: () => (
                <Select
                    allowClear
                    placeholder='请选择状态'
                    options={[
                        { label: "待处理", value: 'ENABLE' },
                        { label: "已处理", value: 'DISABLE' },
                    ]}
                />
            ),
            render: (text: string) => {
                switch (text) {
                    case "ENABLE":
                        return <span style={{ color: 'orange' }}>待处理</span>;
                    case "DISABLE":
                        return <span style={{ color: 'green' }}>已处理</span>;
                    default:
                        return <span>未知</span>;
                }
            }
        },
        {
            title: "反馈时间",
            dataIndex: "createAt",
            align: "center",
            search: false,
        },
        {
            title: "反馈时间",
            dataIndex: "createAt",
            align: "center",
            valueType: "dateRange",
            hideInTable: true,
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            render: (_: any, record: any) => {
                if (record.status === 'ENABLE') {
                    return <Button style={{ color: '#58CCE0' }} type="text" onClick={() => changeStatus(record)}>处理</Button>;
                } else if (record.status === 'DISABLE') {
                    return <Button style={{ color: '#F3C017' }} type="text" onClick={() => changeStatus(record)}>取消处理</Button>;
                }

                return null;
            },
        }
    ];

    const changeStatus = async (item: any) => {
        const data: any = await jsonRequest.put(`/back/health-feedback/change-status/${item.id}`, {})
            .then((resp: any) => resp.json());
        if (data?.code === 0) {
            tableRef.current?.reload();
            message.success("处理成功");
        } else {
            message.error(data?.msg || "处理失败");
        }
    };

    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/health-feedback/page", {
            currentPage: params.current,
            pageSize: params.pageSize,
            queryBeginDate: params?.createAt?.[0],
            queryEndDate: params?.createAt?.[1],
            status: params.status,
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data?.data, success: result.code === 0, total: data?.count };
    };

    return <>
        <h1>弹窗反馈</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 100 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
        />
    </>;
}